import React from "react";
import Productpage from "../../productpage";
import SEO from "../../seo";

export default function BabyCare() {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-care1.jpg",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-care5.jpg",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-cozy3.jpg",
    ],
    productName: "Baby Care",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/logos-09.png",
    descriptionTitle: "",
    descriptionText:
      "Eclipse PU Foam mattress is a scientifically designed mattress with pure foam that allows your kid for easy breathing and circulation of air. It provides added support without compromising on relaxing sleep. This gives an optimal support for a healthy spine. Its special Super Bond Core provides desired firmness that keeps baby’s spine adequately supported. The mattress is Anti-Microbial and ensure proper care for babies.<br/>Dimensions: 120 x 60 x 10 cm MRP:- 3199<br/>140 x 70 x 10 cm MRP:- 4199",

    featuresText: [
      "Envelopes the spine in a gentle yet firm manner",
      "Pressure relieving material for restful sleep",
      "Recognised by leading chiropractors",
      "Supported and well ventilated Bonnell springs",
      "Anti-microbial mattress for proper toddler care",
      "Good and safe night’s rest guaranteed",
    ],
    featuresImage:
      "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-cozy4.jpg",
    warrantyIcons: [
      "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho1.png",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/Orthotherapy5.png",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/2yrwarranty.jpg",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/Orthotherapy2-1.png",
      "https://eclipsemattress.in/wp-content/uploads/2019/12/heavy-knitted.jpg",
    ],

    warrantyImage:
      "https://eclipsemattress.in/wp-content/uploads/2020/02/BABY-CARE.jpg",
  };

  return (
    <div>
      <SEO
        title="Baby Care Kids Mattress | Eclipse International"
        description="Buy baby care mattress at best price that is designed with pure foam that allows kids for easy breathing and circulation of air which giving support to the spine for healthy sleep"
      />
      <Productpage product={data} />
    </div>
  );
}
